import {
	Component, Input, OnInit, OnDestroy, OnChanges, ViewEncapsulation, ChangeDetectionStrategy
} from '@angular/core';
import {IButton, IButtonTranslateTemplate} from "./button.interface";
import {BaseButtonComponent} from "./base.button.component";

/**
 * Button Widget
 */

@Component({
	selector: 'cp-button-widget',
	templateUrl: './button.template.html',
	styleUrls: ['./button.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated
})

export class ButtonComponent extends BaseButtonComponent implements OnInit, OnChanges, OnDestroy {
	@Input() button: IButton;

	ngOnInit() {
		this.baseOnInit();
	}

	ngOnChanges(changes) {
		this.baseOnChanges(changes);
	}

	ngOnDestroy() {
		this.baseOnDestroy();
	}

	get tooltipPlain() : string {
		if (this.button.tooltipPlainSelected && this.button.isSelected) {
			return this.button.tooltipPlainSelected;
		}
		return this.button.tooltipPlain;
	}

	get tooltipToTranslate() : IButtonTranslateTemplate {
		if (this.button.tooltipToTranslateSelected && this.button.isSelected) {
			return this.button.tooltipToTranslateSelected;
		}
		return this.button.tooltipToTranslate;
	}
}
